import type { IOrganizationFeaturePartnerPortalNotification } from './OrganizationFeaturePartnerPortalNotification.interface';

export default class OrganizationFeaturePartnerPortalNotification
  implements IOrganizationFeaturePartnerPortalNotification {
  sms: boolean;
  email: boolean;
  smsContent: string;
  emailContent: string;

  static build = (data: IOrganizationFeaturePartnerPortalNotification) =>
    new OrganizationFeaturePartnerPortalNotification(data);
  static blank = () => new OrganizationFeaturePartnerPortalNotification();

  /**
   * Constructor
   * @param {IOrganizationFeaturePartnerPortalNotification} data
   */
  constructor(data?: IOrganizationFeaturePartnerPortalNotification) {
    this.sms = data?.sms === true;
    this.email = data?.email === true;
    this.smsContent = data?.smsContent || undefined;
    this.emailContent = data?.emailContent || undefined;
  }
}
